import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { MdMeetingRoom } from "react-icons/md";

import { Header } from "../../common";
import RoomsTab from "./components/RoomsTab";

const RoomManagementView = ({
  roomList,
  addRoom,
  editRoom,
  archiveRoom,
  locationList,
  roomPagination,
  listRooms,
  roomManagementPage,
  setRoomManagementPage,
}) => {
  return (
    <div className="room-management-page main__body padding">
      <Header label="Room Management" Icon={MdMeetingRoom} />
      
      <Row className="mt-3">
        <Col md={12}>
          <RoomsTab
            roomList={roomList}
            addRoom={addRoom}
            editRoom={editRoom}
            archiveRoom={archiveRoom}
            locationList={locationList}
            roomPagination={roomPagination}
            listRooms={listRooms}
            roomManagementPage={roomManagementPage}
            setRoomManagementPage={setRoomManagementPage}
          />
        </Col>
      </Row>
    </div>
  );
};

RoomManagementView.propTypes = {
  roomList: PropTypes.array.isRequired,
  addRoom: PropTypes.func.isRequired,
  editRoom: PropTypes.func.isRequired,
  archiveRoom: PropTypes.func.isRequired,
  locationList: PropTypes.array.isRequired,
  roomPagination: PropTypes.object,
  listRooms: PropTypes.func.isRequired,
  roomManagementPage: PropTypes.number,
  setRoomManagementPage: PropTypes.func,
};

export default RoomManagementView;
